"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function CasosDeExito() {
  const cases = [{
    id: 1,
    title: "Feyma 1986",
    excerpt: "Implementamos una estrategia integral de e-commerce y gestión comercial que incrementó las ventas en un 45% en el primer año.",
    image: "https://vokseglobalconsulting.com/wp-content/uploads/2026/01/Feyma1986.png",
    link: "#"
  }, {
    id: 2,
    title: "Optimización de Red Multicartera",
    excerpt: "Reestructuramos la red de representantes logrando mayor eficiencia operativa y un aumento del 30% en la cobertura territorial.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508450/img/sales_network_optimization.png",
    link: "#"
  }, {
    id: 3,
    title: "Rebranding para Sector Industrial",
    excerpt: "Desarrollamos una nueva identidad de marca y estrategia de posicionamiento que mejoró el reconocimiento en un 60%.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508450/img/industrial_rebranding_success.png",
    link: "#"
  }];
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-5xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground mb-4">
            Casos de Éxito
          </h2>
          <p className="text-muted-foreground text-lg">
            Resultados tangibles que transforman negocios
          </p>
        </div>

        <div className="space-y-6">
          {cases.map((caseItem, i) => <Card key={caseItem.id} data-index={i} className="overflow-hidden border border-border hover:shadow-medium transition-all duration-[var(--duration-medium)]">
              <CardContent className="p-0">
                <Link to={caseItem.link} className="flex flex-col md:flex-row gap-6 group">
                  <div className="md:w-64 flex-shrink-0 overflow-hidden">
                    <img src={caseItem.image} alt={caseItem.title} className="w-full h-48 md:h-full object-cover transition-transform duration-[var(--duration-medium)] group-hover:translate-y-[-2px] group-hover:scale-[1.02]" />
                  </div>

                  <div className="flex-1 py-6 pr-6 md:py-8 px-6 md:px-0 flex flex-col justify-center">
                    <h3 className="font-display text-2xl font-semibold text-foreground mb-3 group-hover:text-primary transition-colors duration-[var(--duration-fast)]">
                      {caseItem.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed mb-4">
                      {caseItem.excerpt}
                    </p>
                    <div className="flex items-center text-primary font-semibold group-hover:gap-3 gap-2 transition-all duration-[var(--duration-fast)]">
                      <span>Leer más</span>
                      <ArrowRight className="w-5 h-5" />
                    </div>
                  </div>
                </Link>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}